/**
 * Brand pill styles shared by the consent banner (black bg) and the
 * preferences modal (white bg). Title Case, upright bold — deliberately not
 * the italic/uppercase hero CTA treatment (design spec 2026-07-21).
 * Callers append sizing (px/py/text-*) and ring-offset color for their surface.
 */
const PILL_BASE =
  "inline-flex items-center justify-center whitespace-nowrap rounded-full font-bold leading-none transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan focus-visible:ring-offset-2";

export const PILL_CYAN = `${PILL_BASE} bg-cyan text-black hover:bg-cyan/90 shadow-[0_4px_14px_rgba(68,194,227,0.25)]`;

export const PILL_GHOST_ON_DARK = `${PILL_BASE} border-2 border-white text-white hover:bg-white/10`;

export const PILL_GHOST_ON_LIGHT = `${PILL_BASE} border-2 border-black/25 text-zinc-900 hover:bg-black/5`;
